import { all, call } from "redux-saga/effects";
import onGetQuestions from "./getQuestions";
import onGetQuestion from "./getQuestion";
import onCreateQuestion from "./createQuestion";
import onEditQuestion from "./editQuestion";
import onDeleteQuestion from "./deleteQuestion";
import onCreateQuestionImage from "./createQuestionImage";
import onEditQuestionImage from "./editQuestionImage";
import onGenerateSolution from "./generateSolution";
import onMarkAnswer from "./markAnswer";
import onBulkQuestionsUpload from "./bulkQuestionUpload";
import onGenerateQuestions from "./aiQuestionCreate";
import onSaveGeneratedQuestions from "./saveGeneratedQuestions";
import onGetSchools from "./getSchools"
import onCreateAddknowledge from "./createAddKnowledge"

export default function* questionsSaga() {
  yield all([
    call(onGetQuestions),
    call(onGetQuestion),
    call(onCreateQuestion),
    call(onEditQuestion),
    call(onDeleteQuestion),
    call(onCreateQuestionImage),
    call(onEditQuestionImage),
    call(onGenerateSolution),
    call(onMarkAnswer),
    call(onBulkQuestionsUpload),
    call(onGenerateQuestions),
    call(onSaveGeneratedQuestions),
    call(onGetSchools),
    call(onCreateAddknowledge)
  ]);
}
